// removed by extract-text-webpack-plugin
module.exports = {"page":"AcceptTalent_page__l6wk","form":"AcceptTalent_form__v7DA"};


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/KingstonConnect/styles/AcceptTalent.scss
// module id = 708
// module chunks = 0